import {handleRepositoryDataError} from '@github-ui/data-router-error-helpers'
import {useRouteParams} from '@github-ui/react-core/future/use-route-params'
import {useRouteQuery} from '@github-ui/react-core/future/use-route-query'
// eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-imports -- Transitional: MilestoneEdit's update mutation still uses useRelayEnvironment; removed with the milestone mutation TanStack workstream.
import {relayEnvironmentWithMissingFieldHandlerForNode, RelayEnvironmentProvider} from '@github-ui/relay-environment'
import {AnalyticsWrapper as BaseAnalyticsWrapper} from '@github-ui/repo-issues-page-layout/AnalyticsWrapper'
import {RepoIssuesPageLayout} from '@github-ui/repo-issues-page-layout/RepoIssuesPageLayout'
import {useRepoIssuesSidebarLayoutEnabled} from '@github-ui/repo-issues-page-layout/useSidebarLayoutEnabled'
// eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-imports -- Transitional: reuse the existing Relay-backed edit form; its update mutation is removed by the milestone mutation TanStack workstream.
import {MilestoneEdit as MilestoneEditForm} from '@github-ui/repository-milestone/MilestoneEdit'
import {useMemo} from 'react'

import {issuesLayoutRoute} from './issues-layout-route'
import {milestoneEditRoute} from './milestone-edit-route'
import {useRenderSidebar} from './render-issues-sidebar'
import {useMilestoneCacheSync} from './use-milestone-cache-sync'

export function MilestoneEdit() {
  const {owner, repo} = useRouteParams(milestoneEditRoute)
  const {data: layoutPayload} = useRouteQuery(issuesLayoutRoute, 'mainQuery')
  const payload = useRouteQuery(milestoneEditRoute, 'mainQuery')
  const syncMilestoneCaches = useMilestoneCacheSync(owner, repo)

  const renderSidebarFn = useRenderSidebar(owner, repo, layoutPayload)
  const sidebarLayoutEnabled = useRepoIssuesSidebarLayoutEnabled()

  // MilestoneEdit's update mutation calls useRelayEnvironment() but the data-router issues app
  // has no Relay provider, so supply a local one (the CreateIssueDialog pattern).
  const relayEnvironment = useMemo(() => relayEnvironmentWithMissingFieldHandlerForNode(), [])

  // FORBIDDEN/SAML reloads the page; other errors throw to the boundary.
  const data = handleRepositoryDataError(payload.data)
  if (!data?.repository) {
    return null
  }

  // This leaf owns its own layout so the form keeps its milestone chrome in both sidebar-flag states,
  // matching the Relay page it replaces.
  return (
    <BaseAnalyticsWrapper category="Repository Milestone Edit" appName="issues">
      <RepoIssuesPageLayout
        dialogTitle="Milestones"
        title={sidebarLayoutEnabled ? 'Edit milestone' : undefined}
        renderSidebar={renderSidebarFn}
        initialExpanded={layoutPayload?.sidebarExpanded}
      >
        <RelayEnvironmentProvider environment={relayEnvironment}>
          <MilestoneEditForm repository={data.repository} onMutationSuccess={syncMilestoneCaches} />
        </RelayEnvironmentProvider>
      </RepoIssuesPageLayout>
    </BaseAnalyticsWrapper>
  )
}
